<template>
  <div class="chat-box">
    <!-- search 聊天记录 -->
    <div class="search">
      <el-input :placeholder="chatHistory" prefix-icon="el-icon-search" v-model="searchInput" @change="searchMessage">
      </el-input>
    </div>
    <!-- 显示信息部分 -->
    <div class="title-main">
      <div class="message-list-li" v-for="(item, index) in contentSendList" :key="index">
        <!-- 角色为0 -->
        <div class="message-avt-img-css" v-if="item.role === 0">
          <img :src="item.avatarImg" alt="" />
        </div>
        <div class="message-li-box" v-if="item.role === 0">
          {{ item.title }}
        </div>
        <!-- 角色为1 -->
        <div class="message-avt-img-css1" v-if="item.role === 1">
          <img :src="item.avatarImg" alt="" />
        </div>
        <div class="message-li-box1" v-if="item.role === 1">
          {{ item.title }}
        </div>
      </div>
    </div>
    <!-- 发送信息部分 -->
    <div class="send-message">
      <div class="send-message-main">
        <div class="img-avt">
          <img src="../assets/send-avt.png" alt="" />
        </div>
        <div class="search-main-css">
          <el-input v-model="contentText" :placeholder="pleaseEnterMessage" ref="sendMsg"
            @keyup.enter="websocketsend()">
          </el-input>
        </div>
        <div class="send-button-css" @click="websocketsend">
          <img src="../assets/sendFly.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchInput: "", //搜索聊天input值
      contentText: "", // input输入的值
      contentSendList: [
        // {
        //   title: "内定！おめでとう", //信息内容
        //   role: 0, //判断是自己还是对话那个人
        //   avatarImg: require("../assets/send-avt.png"), //头像图片
        // },
        // {
        //   title: "わぁ！ありがとうございます", //信息内容
        //   role: 1, //判断是自己还是对话那个人
        //   avatarImg: require("../assets/otherSendAvt.png"), //头像图片
        // },
      ], //聊天信息列表
      wsUrl: 'ws://39.107.242.3:9999/modules-parent/medicalSysMsg/sendCurrentUserMsg', // ws地址
      websock: null, // ws实例
      count: 0,
      //当前用户ID
      userId: 0,

    };
  },
  mounted() {
    // this.initWebSocket()
  },
  destroyed() {
    // 离开路由之后断开websocket连接
    // this.websock.close()
  },
  computed: {
    chatHistory() {
      return this.$t("chatHistory");
    },
    pleaseEnterMessage() {
      return this.$t("pleaseEnterMessage");
    },
  },
  created() {
    // this.getUserId();
  },
  mounted() {
    // this.initWebSocket()
  },
  destroyed() {
    // 离开路由之后断开websocket连接
    // this.websock.close()
  },
  methods: {
    searchMessage() { },
    // 初始化weosocket
    initWebSocket() {
      if (typeof WebSocket === 'undefined')
        return console.log('您的浏览器不支持websocket')
      this.websock = new WebSocket(this.wsUrl)
      this.websock.onmessage = this.websocketOnmessage
      this.websock.onopen = this.websocketOnopen
      this.websock.onerror = this.websocketOnerror
      this.websock.onclose = this.websocketClose
    },
    websocketOnopen() {
      // 连接建立之后执行send方法发送数据
      let actions = { test: 'test' }
      this.websocketsend(JSON.stringify(actions))
    },
    websocketOnerror() {
      // 连接建立失败重连
      this.initWebSocket()
    },
    websocketOnmessage(e) {
      // 数据接收
      const reData = JSON.parse(e.data)
      console.log('接收的数据', reData)
    },
    websocketsend(Data) {
      // 数据发送
      this.websock.send(Data)
    },
    websocketClose(e) {
      // 关闭
      console.log('断开连接', e)
    },
  },
  components: {},
  watch: {},
};
</script>
<style scoped>
.chat-box {
  background: #fff;
  min-width: 300px;
  height: 650px;
  overflow: hidden;
  border: 2px solid #b2b2b2;
  border-radius: 8px;
  padding: 0 10px;
  box-shadow: 5px 2px 2px rgba(10, 16, 20, 0.24), 3px 2px 5px rgba(10, 16, 20, 0.12);
}

.search {
  height: 70px;
  width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search /deep/ .el-input__inner {
  background: #f0f0f0;
  border-radius: 4px;
  width: 249px;
  height: 24px;
  line-height: 24px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  border: 1px solid transparent;
}

.search /deep/ .el-input {
  width: 249px;
  height: 24px;
  line-height: 24px;
  border: 1px solid transparent;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.title-main {
  width: 530px;
  height: 500px;
  overflow-y: scroll;
}

.send-message {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.send-message-main {
  width: 285px;
  height: 50px;
  display: flex;
  align-items: center;
}

.img-avt {
  width: 28px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-main-css /deep/ .el-input__inner {
  border: 1px solid transparent;
  width: 230px;
}

.search-main-css /deep/ .el-input {
  width: 230px;
}

.send-button-css {
  width: 25px;
  height: 25px;
  cursor: pointer;
  background: #51abff;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.send-button-css img {
  width: 15px;
  height: 15px;
}

.message-list-li {
  width: 500px;
  min-height: 50px;
  overflow: hidden;
}

.message-li-box {
  min-height: 30px;
  margin-top: 10px;
  max-width: 200px;
  background: #51abff;
  float: right;
  border-radius: 6px 6px 0px 6px;
  line-height: 20px;
  padding: 5px;
  box-sizing: border-box;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #ffffff;
}

.message-avt-img-css {
  width: 35px;
  height: 35px;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 0 10px;
}

.message-li-box1 {
  min-height: 30px;
  margin-top: 10px;
  max-width: 200px;
  float: left;
  background: rgba(252, 99, 12);
  border-radius: 6px 6px 6px 0px;
  line-height: 20px;
  padding: 5px;
  box-sizing: border-box;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-left: 10px;
  letter-spacing: 0.25px;
  color: #ffffff;
}

.message-avt-img-css1 {
  width: 40px;
  height: 40px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/socket.vue